module.exports = __webpack_public_path__ + "img/telegram-courses.b1b70981.png";